export enum SituacaoParteDoProcesso {
  IntegracaoPendente = 'IntegracaoPendente',
  Integrando = 'Integrando',
  Integrado = 'Integrado',
  ComErro = 'ComErro',
}
